/**
 * Detects aborted fetches / Matrix long-poll cancellations.
 * Checks `error.cause` for nested DOMExceptions (e.g. Sentry-instrumented fetch).
 */
export function isAbortError(err) {
  let current = err;
  const seen = new Set();
  while (current && typeof current === 'object' && !seen.has(current)) {
    seen.add(current);
    // Axios: canceled requests (distinct from fetch AbortController)
    if (current.__CANCEL__ === true) return true;
    if (typeof current.code === 'string' && current.code === 'ERR_CANCELED') {
      return true;
    }
    if (typeof current.name === 'string' && current.name === 'CanceledError') {
      return true;
    }
    const name = current?.name;
    if (typeof name === 'string' && name.toLowerCase() === 'aborterror') {
      return true;
    }
    const message =
      (typeof current?.message === 'string' && current.message) ||
      (typeof current?.toString === 'function' && current.toString()) ||
      '';
    if (typeof message === 'string') {
      const lower = message.toLowerCase();
      if (
        lower.includes('the operation was aborted') ||
        lower.includes('aborterror') ||
        lower.includes('signal is aborted') ||
        lower.includes('request was aborted')
      ) {
        return true;
      }
    }
    current = current.cause;
  }
  return false;
}
